export const home = {
  // Navigation
  'nav.home': 'Hjem',
  'nav.spreadsheet': 'Spreadsheet Hub',
  'nav.safety': 'Sikkerhedsguide',
  'nav.about': 'Om',
  'nav.contact': 'Kontakt',
  'nav.categories': 'Kategorier',
  'nav.guide': 'Købsguide',
  'nav.search_placeholder': 'Søg efter spreadsheets, sælgere, produkter...',

  // Hero
  'hero.title': 'Den Ultimative AllChinaBuy Spreadsheet & Købsguide',
  'hero.subtitle': 'Find Bedre Produkter med AllChinaBuy Spreadsheet',
  'hero.description': 'Opdag nyttige AllChinaBuy spreadsheets, sælgere, produktfund, QC-ressourcer, forsendelsesinformation og købsguides — organiseret på ét hurtigt, brugervenligt sted.',
  'hero.cta_primary': 'Udforsk AllChinaBuy Spreadsheet',
  'hero.cta_secondary': 'Gennemse Købsguides',
  'hero.trust_badge': 'Uafhængig ressource • Regelmæssigt opdateret • Bygget til smartere produktsøgning',
  'hero.supporting': 'Uanset om du leder efter et specifikt produkt, sammenligner sælgere, tjekker QC-information eller undersøger forsendelsesomkostninger, samler vores AllChinaBuy Spreadsheet-hub de mest nyttige ressourcer.',

  // Categories
  'categories.title': 'Populære AllChinaBuy Kategorier',
  'categories.description': 'Gennemse vores kuraterede produktkategorier og find præcis det, du leder efter.',
  'categories.all': 'Alle Kategorier',

  // Category names
  'cat.shoes': 'Sko',
  'cat.hoodies': 'Hættetrøjer / Sweaters',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jakker',
  'cat.pants': 'Bukser / Shorts',
  'cat.headwear': 'Hovedbeklædning',
  'cat.sets': 'Sæt',
  'cat.underwear': 'Undertøj / Underbukser',
  'cat.jersey': 'Trøjer',
  'cat.accessories': 'Tilbehør',
  'cat.bags': 'Tasker',
  'cat.belts': 'Bælter',
  'cat.perfumes': 'Parfumer',
  'cat.other': 'Andet',

  // Main website CTA buttons
  'cta.main_button': 'AllChinaBuy Spreadsheet',
  'cta.buy_now': 'Køb Nu',
  'cta.visit_main': 'Besøg Hovedsiden',
  'cta.ready_title': 'Klar til at Udforske Mere?',
  'cta.ready_desc': 'Brug vores AllChinaBuy Spreadsheet-ressourcer til at opdage produkter, sammenligne sælgere og undersøge dit næste køb.',

  // Featured Articles
  'articles.title': 'Seneste AllChinaBuy Guides',
  'articles.description': 'Dybdegående artikler for at hjælpe dig med at træffe smartere købsbeslutninger.',
  'articles.read_more': 'Læs Fuld Guide',
  'articles.all_guides': 'Se Alle Guides',

  // Article titles
  'article.complete_guide': 'AllChinaBuy Spreadsheet: Komplet Guide 2026',
  'article.complete_guide_desc': 'Alt hvad du behøver at vide om brug af AllChinaBuy Spreadsheet — fra at finde sælgere til at verificere produktkvalitet.',
  'article.is_legit': 'Er AllChinaBuy Legit? Komplet Sikkerhedsguide',
  'article.is_legit_desc': 'Vi nedbryder sikkerhed, tillidssignaler og risici ved køb gennem AllChinaBuy. Lær hvordan du beskytter dig selv.',
  'article.shipping': 'AllChinaBuy Forsendelsesomkostninger Guide 2026',
  'article.shipping_desc': 'Detaljeret nedbrydning af forsendelsesmetoder, omkostninger efter land og tips til at spare på leveringsgebyrer.',
  'article.coupon': 'AllChinaBuy Kupon & Rabatkode Guide',
  'article.coupon_desc': 'Sådan finder og bruger du AllChinaBuy-kuponer, rabatkoder og sæsonkampagner for maksimal besparelse.',
  'article.review': 'AllChinaBuy Anmeldelse: Funktioner & Købsoplevelse',
  'article.review_desc': 'En ærlig, uafhængig anmeldelse af AllChinaBuy-platformen dækkende søgning, bestilling, QC og forsendelse.',
  'article.qc': 'AllChinaBuy QC Foto Guide: Hvad du Skal Kigge Efter',
  'article.qc_desc': 'Lær at læse QC-fotos, spotte fejl og godkende eller afvise varer før de sendes.',
  'article.how_to_use': 'Sådan Bruger du AllChinaBuy Spreadsheet',
  'article.how_to_use_desc': 'En trin-for-trin gennemgang af spreadsheet-grænsefladen, fra at gennemse kategorier til din første ordre.',
  'article.seller_guide': 'AllChinaBuy Sælgerguide: Find Pålidelige Sælgere',
  'article.seller_guide_desc': 'Sådan vurderer du sælgers omdømme, anmeldelser og kommunikation før du køber.',
  'article.beginner_guide': 'AllChinaBuy Begynderguide: Start med Tillid',
  'article.beginner_guide_desc': 'En komplet introduktion for førstegangskøbere dækkende konti, ordrer, QC og forsendelse.',
  'article.best_finds': 'Bedste AllChinaBuy Fund: Produkter Værd at Købe',
  'article.best_finds_desc': 'Vores kuraterede udvalg af trending sko, tøj, tasker og tilbehør værd at tjekke ud.',
  'article.warehouse': 'AllChinaBuy Lagerhus Guide: Opbevaring, QC & Forsendelse',
  'article.warehouse_desc': 'Forstå hvordan lagerhuset opbevarer, inspicerer og konsoliderer dine ordrer før forsendelse.',
  'article.alternatives': 'AllChinaBuy Alternativer: Platforme Sammenlignet',
  'article.alternatives_desc': 'En afbalanceret sammenligning af AllChinaBuy og andre shopping agent platforme.',
  'article.payment': 'AllChinaBuy Betalings- & Refusionsguide',
  'article.payment_desc': 'Betalingsmetoder, refusionspolitikker og hvordan du løser problemer med dine ordrer.',
  'article.tracking': 'AllChinaBuy Sporingsguide: Følg Din Ordre',
  'article.tracking_desc': 'Sådan sporer du din pakke fra lagerhus til døren med nyttige tips.',
  'article.qc_checklist': 'AllChinaBuy QC Tjekliste: Verificer Før Forsendelse',
  'article.qc_checklist_desc': 'En printbar tjekliste over hvad du skal tjekke i QC-fotos før godkendelse af forsendelse.',
  'article.best_sellers': 'Bedste AllChinaBuy Sælgere 2026: Pålidelige Butikker',
  'article.best_sellers_desc': 'De sælgere med det stærkeste omdømme på tværs af populære produktkategorier.',

  // Trust section
  'trust.title': 'Er AllChinaBuy Sikker at Bruge?',
  'trust.subtitle': 'Vores uafhængige sikkerhedsvurdering',
  'trust.desc': 'Vi har analyseret AllChinaBuy-platformen uafhængigt. Dette site er ikke tilknyttet AllChinaBuy. Vi leverer ærlig, forskningsbaseret information for at hjælpe dig med at træffe informerede beslutninger.',
  'trust.checklist_title': 'Sikkerhedstjekliste Før Køb',
  'trust.check_1': 'Verificer sælgers omdømme og anmeldelser',
  'trust.check_2': 'Tjek QC-fotos før godkendelse af forsendelse',
  'trust.check_3': 'Brug sikre betalingsmetoder',
  'trust.check_4': 'Sammenlign forsendelsesomkostninger og metoder',
  'trust.check_5': 'Læs nylige køberoplevelser',
  'trust.read_more': 'Læs Fuld Sikkerhedsguide',

  // FAQ
  'faq.title': 'Ofte Stillede Spørgsmål',
  'faq.q1': 'Hvad er AllChinaBuy Spreadsheet?',
  'faq.a1': 'AllChinaBuy Spreadsheet er en kurateret samling af produktlinks, sælgerinformation og købsressourcer, der hjælper shoppere med at finde kvalitetsprodukter via AllChinaBuy-platformen. Det organiserer produkter efter kategori med links, priser og sælgerbedømmelser.',
  'faq.q2': 'Hvordan bruger jeg AllChinaBuy Spreadsheet?',
  'faq.a2': 'Gennemse blot de kategorier, der interesserer dig, klik på produktlinks for at se detaljer på AllChinaBuy-platformen, og følg købsguides for en smidig købsoplevelse. Vi anbefaler at starte med vores Komplet Guide for begyndere.',
  'faq.q3': 'Er AllChinaBuy legit?',
  'faq.a3': 'AllChinaBuy er en kendt shopping agent platform. Som ethvert online marketplace varierer køberoplevelser. Vi anbefaler at læse vores uafhængige sikkerhedsguide, tjekke sælgeranmeldelser og altid bruge QC-fotos før godkendelse af forsendelser.',
  'faq.q4': 'Hvad koster AllChinaBuy-forsendelse?',
  'faq.a4': 'Forsendelsesomkostninger varierer efter destination, vægt og forsendelsesmetode. Vores forsendelsesomkostningsguide giver detaljerede estimater for USA, UK, Tyskland, Frankrig, Danmark og andre lande.',
  'faq.q5': 'Har AllChinaBuy kuponer?',
  'faq.a5': 'AllChinaBuy tilbyder lejlighedsvis kuponer og rabatkoder. Tjek vores kuponguide for de seneste tilbud og tips til at maksimere dine besparelser.',

  // Footer
  'footer.about_title': 'Om Dette Site',
  'footer.about_desc': 'AllChinaBuySpread er et uafhængigt ressource-hub. Vi er ikke officielt tilknyttet AllChinaBuy. Al information er kun til forsknings- og uddannelsesformål.',
  'footer.links_title': 'Hurtige Links',
  'footer.link_safety': 'Sikkerhedsguide',
  'footer.link_about': 'Om Os',
  'footer.link_contact': 'Kontakt',
  'footer.link_disclaimer': 'Ansvarsfraskrivelse',
  'footer.legal': 'Dette er et uafhængigt ressourcewebsite. Produktlinks omdirigerer til AllChinaBuy og kaspreadsheet.com.',
  'footer.copyright': '© 2026 AllChinaBuySpread. Alle rettigheder forbeholdes.',

  // Common
  'common.loading': 'Indlæser...',
  'common.read_time': 'min læsning',
  'common.updated': 'Opdateret',
  'common.independent': 'Uafhængig Ressource',
};